import LeftImageArea from '../components/LeftImageArea';
import Support from '../components/Support';
import '../components/registration.css';

const AuthLayout = ({ children }) => {
  return (
    <div className="d-lg-flex half">
      <div className="contents order-md-2 form-area">
        <div className="flex flex-column">
          <div
            className="row align-items-center justify-content-center"
            style={{ height: '95vh' }}
          >
            {children}
          </div>
          <span className="float-right font-italic for-help mr-2">
            Help Line:
            <i className="fas fa-phone-alt" style={{ fontSize: '14px' }}></i>
            <span>01841841101</span>
          </span>
        </div>
      </div>
      <LeftImageArea />
    </div>
  );
};

export default AuthLayout;
